import { WithChildren } from "../helpers/constants/types";

export const Content: React.FC<WithChildren> = ({ children }) => {
  return <>{children}</>;
};
